import { render } from "./Down Town Mall.vue?vue&type=template&id=6e1515d8&scoped=true"
const script = {}

import "./Down Town Mall.vue?vue&type=style&index=0&id=6e1515d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e1515d8"

export default script